import { getPageAssets, initGlobalComponents } from './core';

fetchAdditionalAssets().then(initGlobalComponents);

async function fetchAdditionalAssets() {

  /* Load FontAwesome CSS asynchronously */
  import('font-awesome/css/font-awesome.css');

  getPageAssets().forEach(file => {
    import(/* webpackChunkName: "[request]" */`./modules/${file}`);
  });
}
